import { Options, Vue } from 'vue-class-component';

import { getUserMenuList } from "@/api/backstage";
import { NavsDto } from '@/model/web/NavsDto';



@Options({})
export default class Asides extends Vue {
    public navs: NavsDto[] = []; 
     // 获取导航菜单
     public getMenuList() {
        getUserMenuList('MENU_CLASSFIER_BACKSTAGE').then((res: any) => {
            // for (const item of res.data) {
            //     item.path === this.$route.path ? item.checked = true : item.checked = false;
            // }
            this.navs = res.data;
            this.$router.replace(res.data[0].children[0].path);
        });
    }

    public mounted() {
        this.getMenuList();
    }
}